module.exports = __webpack_public_path__ + "static/media/start-quiz.532d7406.png";